import React from 'react';
import ExtractTransformLoad from "../../../images/ExtractTransformLoad.png";
import Modal from "../../Common/Modals/Modal";
import StyledImageFluid from "../Image.styled";
import {Color} from "../../Common/Colors";
import Button from "../../Common/Buttons/Button";

const AppDevSupportModalButton = () => {

    const [isOpen, setIsOpen] = React.useState(false);

    const showModal = () => {
        setIsOpen(true);
    };

    const hideModal = () => {
        setIsOpen(false);
    };

    return (
        <div>
            <Button type="button" className="btn btn-primary" onClick={showModal}>Read more...</Button>
            <Modal id="ETLModal"
                   title="Application Development &amp; Support"
                   onClose={hideModal}
                   show={isOpen}>
                <StyledImageFluid src={ExtractTransformLoad} alt="Extract Transform Load"
                                  backgroundColor={Color.lightyellow}
                                  rounded borderPlatinum/>
                <p><strong>Extract Transform and Load(ETL)</strong> experience with data capture and extraction
                    processes, transforming content for value add via data pipelines, and loading content into
                    global data repositories access by external applications.</p>
                <ul>
                    <li>Responsible for implementing, enhancing, and supporting several different proprietary
                        hierarchical, topical, and editorial applications used by internal legal attorneys and
                        compliance staff.
                        <ul>
                            <li>The hierarchical and topical application systems served as an index and controlling
                                structure into the content.
                            </li>
                            <li>The editorial applications served as an xml document repository allowing users
                                direct content manipulation from within a web browser.
                            </li>
                        </ul>
                    </li>
                </ul>
            </Modal>
        </div>
    );
}

export default AppDevSupportModalButton;